import BookingEngineSetting from "../../components/profile/BookingEngineSetting/Index";

const Index = () => {
  return (
    <div>
      <BookingEngineSetting fullPage />
    </div>
  );
};

export default Index;
